import { DataProvider } from 'assets/providers/data/DataProvider';
import ErrorPage from 'assets/templates/errorPage/ErrorPage';
import { HttpStatus, productManagementHomeRoute } from 'config/Api.Config';
import useProductEnhancementDocument, { ProductEnhancementDocumentTabs } from './ProductEnhancementDocument.Hooks';
import useProductEnhancementDealerDocument from './dealers/ProductEnhancementDocument.DealerDocuments.Hooks';
import ProductEnhancementDealerDocumentIndex from './dealers/ProductEnhancementDocument.DealerDocuments.Index';
import useProductEnhancementDealerGroupDocument from './dealerGroups/ProductEnhancementDocument.DealerGroupDocuments.Hooks';
import ProductEnhancementDealerGroupDocumentIndex from './dealerGroups/ProductEnhancementDocument.DealerGroupDocuments.Index';

enum Actions {
  ADD = 'add',
  DELETE = 'delete',
}
export type Verify = Utils.VerifyExtends<
  Module.ProductManagement.ProductDocument.Actions,
  Utils.ValueOf<typeof Actions>
>;
export const productEnhancementDocumentIndexRoute = productManagementHomeRoute + '/productEnhancementDocument/:id?';
export default function ProductEnhancementDocumentIndex() {
  const productEnhancementDocumentHook = useProductEnhancementDocument();
  const productEnhancementDealerDocumentHook = useProductEnhancementDealerDocument();
  const productEnhancementDealerGroupDocumentHook = useProductEnhancementDealerGroupDocument();

  if (!productEnhancementDocumentHook.canView) return <ErrorPage status={HttpStatus.unauthorized} />;
  return (
    <DataProvider
      data={{
        productEnhancementDocumentHook: productEnhancementDocumentHook,
        productEnhancementDealerDocumentHook: productEnhancementDealerDocumentHook,
        productEnhancementDealerGroupDocumentHook: productEnhancementDealerGroupDocumentHook,
      }}
      render={({ productEnhancementDocumentHook }) =>
        productEnhancementDocumentHook.selectedTab === ProductEnhancementDocumentTabs.DEALERS ? (
          <ProductEnhancementDealerDocumentIndex />
        ) : (
          <ProductEnhancementDealerGroupDocumentIndex />
        )
      }
    />
  );
}
